<!--suppress TypeScriptUnresolvedFunction -->
<div fxLayout="column" class="mqtt-config-container">
    <div fxLayout="row">
        <form novalidate [formGroup]="form" fxLayout="column" fxLayoutGap="0.5rem" fxFlex="50" class="mqtt-form">
            <div class="txt-h-20-7">{{'Access details'|i18n}}</div>
            <div fxLayout="row" fxLayoutAlign="start center" class="mt-20">
                <div fxFlex="33" class="txt-p-16-4">{{'Type'|i18n}}:</div>
                <div class="txt-p-16-4">{{cfg.type|connectorType}}</div>
            </div>
            <div app-input-container fxLayout="row" fxLayoutAlign="start center">
                <div fxFlex="33" class="txt-p-16-4">{{'Host'|i18n}}:</div>
                <input app-input formControlName="host" fxFlex="60" class="txt-p-16-4" [maxLength]="HOST_MAX_CHARS">
                <div *ngIf="!form.controls.host.valid" class="ml-10 txt-a-16-7">
                    {{'Invalid host'|i18n}}
                </div>
            </div>
            <div app-input-container fxLayout="row" fxLayoutAlign="start center">
                <div fxFlex="33" class="txt-p-16-4">{{'Port'|i18n}}:</div>
                <input app-input formControlName="port" type="number" fxFlex="60" class="txt-p-16-4"
                       [maxLength]="DEFAULT_MAX_CHARS">
                <div *ngIf="!form.controls.port.valid" class="ml-10 txt-a-16-7">
                    {{'Invalid port'|i18n}}
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <div fxFlex="33" class="txt-p-16-4">{{'Authentication type'|i18n}}:</div>
                <mat-select app-small-select formControlName="authType" fxFlex="60" class="txt-p-16-4"
                            (selectionChange)="onAuthTypeChange($event)">
                    <mat-option *ngFor="let authType of MQTT_AUTH_TYPES" [value]="authType" class="txt-p-16-4">
                        {{authType|mqttAuthType|i18n}}
                    </mat-option>
                </mat-select>
                <div *ngIf="!form.controls.authType.valid" class="ml-10 txt-a-16-7">
                    {{'Invalid authentication type'|i18n}}
                </div>
            </div>
            <ng-container *ngIf="form.controls.authType.value === AuthType.CREDENTIALS">
                <div app-input-container fxLayout="row" fxLayoutAlign="start center">
                    <div fxFlex="33" class="txt-p-16-4">{{'User name'|i18n}}:</div>
                    <input app-input formControlName="user" autocomplete="username" fxFlex="60" class="txt-p-16-4"
                           [maxLength]="DEFAULT_MAX_CHARS">
                    <div *ngIf="!form.controls.user.valid" class="ml-10 txt-a-16-7">
                        {{'Invalid user name'|i18n}}
                    </div>
                </div>
                <div app-input-container fxLayout="row" fxLayoutAlign="start center">
                    <div fxFlex="33" class="txt-p-16-4">{{'Password'|i18n}}:</div>
                    <input app-input formControlName="pass" type="password"
                           fxFlex="60" class="txt-p-16-4" [maxLength]="DEFAULT_MAX_CHARS"
                           (click)="onPasswordControlInteraction()"
                           (keydown)="onPasswordControlInteraction()">
                    <div *ngIf="!form.controls.pass.valid" class="ml-10 txt-a-16-7">
                        {{'Invalid password'|i18n}}
                    </div>
                </div>
            </ng-container>
        </form>
        <div *ngIf="supportedDevTypes.length === 1">
            <div class="field-label mt-20 ml-24">
                <span class="txt-h-16-7">{{'Device type'|i18n}}</span>:
                <span>&nbsp;{{supportedDevTypes[0]|mqttDeviceType}}</span>
            </div>
        </div>
    </div>
    <div fxLayout="row" class="txt-h-16-4">
        <div *ngIf="form.controls.authType.value === AuthType.CERTIFICATES" fxLayout="row" fxLayoutAlign="start center"
             fxLayoutGap="20px" class="cert-panel mt-20" fxFlex="50">
            <app-icon name="fas-info-circle"></app-icon>
            <div>{{'Certificate files are to be specified in connector\'s static configuration.'|i18n}}</div>
        </div>
    </div>
    <div fxLayout="column" class="devices-panel mt-30">
        <div class="txt-h-20-7">{{'Devices list'|i18n}}</div>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-22 mb-32">
            <div app-input-container class="device-search-container">
                <input app-input #deviceSearch class="device-search" [formControl]="deviceSearchCtrl"
                       [matAutocomplete]="deviceSearchAutocomplete" [spellcheck]="false"
                       [placeholder]="'Search device by ID'|i18n"
                       (focusout)="onDeviceSearchLoseFocus($event)">
                <app-icon *ngIf="!!deviceSearchCtrl.value" name="fal-times" class="right-symbol clear"
                          (click)="onClickResetDeviceSearch()">
                </app-icon>
                <mat-autocomplete #deviceSearchAutocomplete="matAutocomplete"
                                  [displayWith]="displaySearchDevice.bind(this)"
                                  (optionSelected)="onSelectSearchDevice($event)">
                    <mat-option *ngFor="let filteredVdevCfg of filteredDevices|async; trackBy: trackByVdevId"
                                [value]="filteredVdevCfg"
                                data-connectorDevice="true">
                        {{filteredVdevCfg.vdevId}}
                    </mat-option>
                </mat-autocomplete>
                <svg *ngIf="!deviceSearchCtrl.value" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                     class="right-symbol mag-glass">
                    <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                </svg>
            </div>
            <button app-primary-button class="add-vdev-button"
                    (click)="onClickAddVirtualDevice()">
                <app-icon name="fal-plus-square"></app-icon>
                {{'Add device'|i18n}}
            </button>
        </div>
        <ng-container *appVar="pagedVDevs|async as vDevs">
            <div *ngIf="vDevs && !selectedDev" class="accordion-panel">
                <mat-accordion>
                    <mat-expansion-panel
                            *ngFor="let vdev of vDevs.data; trackBy: trackByVdevId"
                            togglePosition="before" class="exp-panel"
                            [expanded]="vdev.vdevId === vDevToExpand">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <div class="txt-h-16-7 ml-36">{{vdev.vdevId}}</div>
                                    <button *ngIf="vdev.newlyCreated" app-icon-button class="ml-32"
                                            [title]="'Rename device'|i18n"
                                            (click)="onClickRenameVirtualDevice(vdev, $event)">
                                        <app-icon name="fal-pencil-alt"></app-icon>
                                    </button>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-container *ngTemplateOutlet="vdevDetails; context: {vdev: vdev}">
                        </ng-container>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
            <mat-paginator #paginator app-paginator class="mqtt-paginator"
                           [ngClass]="{'collapsed': !vDevs || vDevs.total === 0 || !!selectedDev}"
                           [length]="vDevs?.total" [pageSize]="PAGE_SIZE"
                           [pageSizeOptions]="PAGE_SIZES">
            </mat-paginator>
            <ng-container *ngIf="selectedDev">
                <ng-container *ngTemplateOutlet="vdevDetails; context: {vdev: selectedDev}">
                </ng-container>
            </ng-container>
            <ng-template #vdevDetails let-vdev="vdev">
                <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="0.5rem" class="mt-36 mb-16">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <ng-container *ngIf="vdev === selectedDev">
                            <div class="txt-h-20-7">{{vdev.vdevId}}</div>
                            <button *ngIf="vdev.newlyCreated" app-icon-button class="ml-32"
                                    [title]="'Rename device'|i18n"
                                    (click)="onClickRenameVirtualDevice(vdev, $event)">
                                <app-icon name="fal-pencil-alt"></app-icon>
                            </button>
                        </ng-container>
                    </div>
                    <button app-ghost-button class="delete-device-button"
                            (click)="onClickDeleteVirtualDevice(vdev)">
                        <app-icon name="fal-trash-alt" class="mr-16"></app-icon>
                        {{'Delete device'|i18n}}
                    </button>
                </div>
                <form novalidate [formGroup]="vdev.form" fxLayout="column" fxLayoutGap="50px"
                      class="vdev-form">
                    <div fxLayout="row">
                        <div fxFlex="50" fxLayout="row" fxLayoutGap="80px">
                            <div *ngIf="supportedDevTypes.length !== 1">
                                <div class="field-label">
                                    <span class="txt-h-16-7">
                                        {{'Device type'|i18n}}:<ng-container
                                            *ngIf="vdev.newlyCreated && supportedDevTypes.length !== 1">*
                                        </ng-container>
                                    </span>
                                    <span *ngIf="!vdev.newlyCreated || supportedDevTypes.length === 1">
                                        &nbsp;{{vdev.form.controls.devType.value|mqttDeviceType}}
                                    </span>
                                </div>
                                <div *ngIf="vdev.newlyCreated && supportedDevTypes.length !== 1"
                                     app-input-container class="mt-20">
                                    <mat-select app-small-select formControlName="devType"
                                                class="txt-p-16-4 dev-type"
                                                (selectionChange)="onVirtualDeviceTypeChange(vdev)">
                                        <mat-option *ngFor="let devType of supportedDevTypes"
                                                    [value]="devType">
                                            {{devType|mqttDeviceType}}
                                        </mat-option>
                                    </mat-select>
                                    <div app-error
                                         *ngIf="vdev.form.controls.devType.invalid && vdev.form.controls.devType.dirty">
                                        {{'Invalid device type'|i18n}}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="field-label">
                                    <span class="txt-h-16-7">
                                        {{'Device serial number'|i18n}}:
                                    </span>
                                    <span>
                                        &nbsp;{{vdev.form.controls.deviceSerial.value}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div fxFlex="50">
                            <div class="field-label">
                                <span class="txt-h-16-7">
                                    {{'System'|i18n}}:<ng-container *ngIf="vdev.newlyCreated">*
                                </ng-container>
                                </span>
                                <span *ngIf="!vdev.newlyCreated && vdev.form.controls.phases.value === Phases.SINGLE">
                                    &nbsp;{{'Single phase'|i18n}}
                                </span>
                                <span *ngIf="!vdev.newlyCreated && vdev.form.controls.phases.value === Phases.THREE">
                                    &nbsp;{{'Three phase'|i18n}}
                                </span>
                            </div>
                            <div class="mt-20">
                                <mat-radio-group *ngIf="vdev.newlyCreated" formControlName="phases"
                                                 class="txt-p-16-4"
                                                 (change)="onVirtualDevicePhasesChange(vdev)">
                                    <mat-radio-button app-radio-button class="mr-24"
                                                      [value]="Phases.SINGLE">
                                        {{'Single phase'|i18n}}
                                    </mat-radio-button>
                                    <mat-radio-button app-radio-button
                                                      [value]="Phases.THREE">
                                        {{'Three phase'|i18n}}
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="vdev.newlyCreated" fxLayout="row">
                        <div fxFlex="50">
                            <div class="field-label">
                                <span class="txt-h-16-7">
                                    {{'Energy profile'|i18n}}:*
                                </span>
                            </div>
                            <div class="mt-20">
                                <mat-radio-group formControlName="energyProfile"
                                                 fxLayout="row" fxLayoutGap="48px" class="txt-p-16-4"
                                                 (change)="onVirtualDeviceEnergyProfileChange(vdev, $event)">
                                    <mat-radio-button app-radio-button
                                                      *ngFor="let energyProfile of MQTT_ENERGY_PROFILES"
                                                      [value]="energyProfile">
                                        {{energyProfile|i18n}}
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div fxFlex="50">
                            <ng-container
                                    *ngIf="vdev.form.controls.energyProfile.value === MqttEnergyProfile.PRODUCER_PROSUMER">
                                <div class="field-label">
                                    <span class="txt-h-16-7">
                                        {{'Number of production meters'|i18n}}:*
                                    </span>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px"
                                     class="mt-20">
                                    <div app-input-container>
                                        <input app-input formControlName="productionPlants" type="number"
                                               class="txt-p-16-4 max-prod-pods"
                                               [min]="1" [max]="getMaxProductionPlants(vdev)"
                                               (input)="onVirtualDeviceProductionPlantsChange(vdev)">
                                        <div app-error
                                             *ngIf="vdev.form.controls.productionPlants.invalid && vdev.form.controls.productionPlants.dirty">
                                            {{'Invalid number of production meters'|i18n}}
                                        </div>
                                    </div>
                                    <div fxFlexAlign="center" class="max-prod-pods-icon">
                                        <app-icon name="fas-info-circle" icon-color-h
                                                  [title]="'Number of M2 meters or production plant sections.'|i18n">
                                        </app-icon>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </form>
                <ng-container *ngIf="getVdevMqttMeasures(vdev) as vdevMqttMeasures">
                    <!-- Production meter(s) -->
                    <div *ngIf="getProductionMeasures(vdevMqttMeasures) as productionMeasures"
                         class="measures-panel mt-16">
                        <div class="txt-h-20-7 mb-36 measures-title">
                            <app-icon name="fal-solar-panel" class="mr-16"></app-icon>
                            {{'Production meters'|i18n}}
                        </div>
                        <div fxLayout="column" fxLayoutGap="40px">
                            <div *ngFor="let prodRow of getProductionPlantRows(productionMeasures); trackBy: trackByIndex"
                                 fxLayout="row">
                                <ng-container
                                        *ngFor="let prodMeas of prodRow; trackBy: trackByIndex; let last=last">
                                    <div fxLayout="column" fxFlex="49.5">
                                        <div class="txt-h-16-7 mb-16">
                                            {{'Plant {0}'|i18n:prodMeas.plantIndex}}
                                        </div>
                                        <div fxLayout="row" fxLayoutGap="24px">
                                            <div *ngIf="vdev.newlyCreated" class="mb-16">
                                                <ng-container
                                                        *ngTemplateOutlet="productionPod; context: {vdev: vdev, control: vdev.form.controls[mkProductionPlantPodControlName(prodMeas.plantIndex)], plantIndex: prodMeas.plantIndex}">
                                                </ng-container>
                                            </div>
                                            <div *ngIf="getVdevPhases(vdev) === Phases.THREE" class="mb-16">
                                                <ng-container
                                                        *ngTemplateOutlet="transformationConstant; context: {vdev: vdev, control: vdev.form.controls[mkProductionPlantKControlName(prodMeas.plantIndex)], center: false}">
                                                </ng-container>
                                            </div>
                                        </div>
                                        <div class="measures-subpanel">
                                            <div class="txt-h-18-7 mb-12">
                                                {{'Production measures'|i18n}}
                                            </div>
                                            <ng-container
                                                    *ngTemplateOutlet="measures; context: {vdev: vdev, measIds: prodMeas.measureIds}">
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div *ngIf="!last" fxFlex="1"></div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <!-- Exchange meter -->
                    <div *ngIf="vdevMqttMeasures.absorptionMeasures.length || vdevMqttMeasures.injectionMeasures.length"
                         class="measures-panel mt-16 mb-64">
                        <div class="txt-h-20-7 mb-36 measures-title">
                            <app-icon name="fal-plug" class="mr-16"></app-icon>
                            {{'Exchange meter'|i18n}}
                        </div>
                        <div *ngIf="getVdevPhases(vdev) === Phases.THREE" class="mt-28 mb-24">
                            <ng-container
                                    *ngTemplateOutlet="transformationConstant; context: {vdev: vdev, control: vdev.form.controls['m1K'], center: true}">
                            </ng-container>
                        </div>
                        <div fxLayout="row">
                            <div *ngIf="vdevMqttMeasures.absorptionMeasures.length" fxFlex="49.5"
                                 class="measures-subpanel">
                                <div class="txt-h-18-7 mb-12">
                                    {{'Absorption measures'|i18n}}
                                </div>
                                <ng-container
                                        *ngTemplateOutlet="measures; context: {vdev: vdev, measIds: vdevMqttMeasures.absorptionMeasures}">
                                </ng-container>
                            </div>
                            <div fxFlex="1"></div>
                            <div *ngIf="vdevMqttMeasures.injectionMeasures.length" fxFlex="49.5"
                                 class="measures-subpanel">
                                <div class="txt-h-18-7 mb-12">
                                    {{'Injection measures'|i18n}}
                                </div>
                                <ng-container
                                        *ngTemplateOutlet="measures; context: {vdev: vdev, measIds: vdevMqttMeasures.injectionMeasures}">
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-template>
        </ng-container>
    </div>
</div>

<ng-template #productionPod let-vdev="vdev" let-control="control" let-plantIndex="plantIndex">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
        <div class="field-label">
            <span class="txt-h-16-7">
                {{'Production POD'|i18n}}:<ng-container *ngIf="vdev.newlyCreated">*
                </ng-container>
            </span>
            <span *ngIf="!vdev.newlyCreated">
                &nbsp;{{control.value|niceValue}}
            </span>
        </div>
        <div *ngIf="vdev.newlyCreated" app-input-container>
            <input app-input [formControl]="control"
                   class="txt-p-16-4 production-pod"
                   (input)="onVirtualDeviceProductionPodChange(vdev, plantIndex)">
            <div app-error *ngIf="control.hasError('pod') && control.dirty">
                {{'Invalid POD'|i18n}}
            </div>
            <div app-error *ngIf="control.hasError('unique_pod') && control.dirty">
                {{'POD already existing'|i18n}}
            </div>
        </div>
        <app-icon name="fas-info-circle"
                  [title]="('14 or 15 digit alphanumeric code, example: ITP0AE123456789'|i18n)">
        </app-icon>
    </div>
</ng-template>

<ng-template #transformationConstant let-vdev="vdev" let-control="control" let-center="center">
    <div fxLayout="row" [fxLayoutAlign]="(center ? 'center' : 'start') + ' center'" fxLayoutGap="24px">
        <div class="field-label">
            <span class="txt-h-16-7">
                {{'Transformation constant'|i18n}}:<ng-container *ngIf="vdev.newlyCreated">*
                </ng-container>
            </span>
            <span *ngIf="!vdev.newlyCreated">
                &nbsp;{{control.value|niceValue}}
            </span>
        </div>
        <div *ngIf="vdev.newlyCreated" app-input-container>
            <input app-input [formControl]="control" type="number"
                   class="txt-p-16-4 transformation-constant"
                   [min]="1" [max]="MQTT_MAX_K">
            <div app-error *ngIf="control.invalid && control.dirty">
                {{'Invalid transformation constant'|i18n}}
            </div>
        </div>
    </div>
</ng-template>

<ng-template #addOrRenameVirtualDevice let-data let-close="close">
    <div class="add-vdev">
        <div [formGroup]="data.form" fxLayout="column" fxLayoutGap="26px">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <div fxFlex="30" class="field-label t-right">
                    POD:
                </div>
                <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <div app-input-container>
                        <input app-input formControlName="pod" class="txt-p-16-4 fix-input-field" maxlength="15">
                        <div app-error *ngIf="data.form.controls.pod.invalid && data.form.controls.pod.dirty">
                            {{'Invalid POD'|i18n}}
                        </div>
                    </div>
                    <app-icon name="fas-info-circle"
                              [title]="('14 or 15 digit alphanumeric code'|i18n) + '\n' + ('Example: IT001E123456789'|i18n)">
                    </app-icon>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <div fxFlex="30" class="field-label t-right">
                    {{'Device serial number'|i18n}}:
                </div>
                <div fxFlex>
                    <div app-input-container>
                        <input app-input formControlName="serial" class="txt-p-16-4 input-field"
                               [maxLength]="ID_MAX_CHARS">
                        <div app-error *ngIf="data.form.controls.serial.invalid && data.form.controls.serial.dirty">
                            {{'Invalid serial number'|i18n}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *appVar="data.idMaker() as devId" class="t-center mt-64 mb-64 txt-p-14-4">
            <div *ngIf="data.form.hasError('duplicate')" class="txt-a-14-7">
                {{'Duplicated device ID {0}'|i18n:devId}}
            </div>
            <ng-container *ngIf="!data.form.hasError('duplicate') && !devId">
                {{'Device id will be shown here'|i18n}}
            </ng-container>
            <ng-container *ngIf="!data.form.hasError('duplicate') && devId">
                <div>{{'Device ID is'|i18n}}:</div>
                <div class="txt-p-14-7">{{devId}}</div>
            </ng-container>
        </div>
        <div fxLayout="row" fxLayoutAlign="center" app-dialog-actions>
            <button app-primary-button [disabled]="!data.form.valid"
                    (click)="close(true)">
                {{'Confirm'|i18n}}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #deleteVirtualDevice let-close="close">
    <div class="t-center txt-a-18-7">
        {{'Warning: this will stop measures for POD resource'|i18n}}
    </div>
    <div class="t-center mt-30 p-16-4">
        {{'Measure for POD resource will be stopped immediately.'|i18n}}
    </div>
    <div class="t-center mt-8 mb-64 p-16-4">
        {{'You will still be able to create a new device and assign its measures to the resource.'|i18n}}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{'No, cancel'|i18n}}
        </button>
        <button app-primary-button (click)="close(true)">
            {{'Yes, confirm'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #measures let-vdev="vdev" let-measIds="measIds">
    <div fxLayout="column" fxLayoutGap="22px" class="mt-40">
        <div *ngFor="let meas of getVdevMeasureConfigs(vdev, measIds); trackBy: trackByMeasId" fxLayout="row">
            <div fxFlex="40" class="txt-p-14-7">
                {{formatMeasureType(vdev, meas.measId)|i18n}}:
            </div>
            <div fxFlex="60" class="txt-p-14-4">
                {{meas.measId}}
            </div>
        </div>
    </div>
</ng-template>
